import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { ControllerService } from 'src/app/services/controller.service';
import { environment } from 'src/environments/environment';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { StorageService } from 'src/app/services/storage.service';

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
  selector: 'app-data-export',
  templateUrl: './data-export.component.html',
  styleUrls: ['./data-export.component.css'],
})
export class DataExportComponent implements OnInit {
  delete_account_message: boolean = false;
  submited: boolean = false;
  siteKey = environment.siteKey;
  protected aform_group!: FormGroup;
  fa_lock = faLock;
  exportForm = new FormGroup({
    email: new FormControl(''),
    recaptcha: new FormControl(''),
  });
  recaptcha_response: any;
  email_validate: any = true;
  field_empty: boolean = true;
  constructor(
    private router: Router,
    private _controller_service: ControllerService,
    private form_builder: FormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service,
    private storage: StorageService
  ) {}
  ngOnInit(): void {
    this.aform_group = this.form_builder.group({
      recaptcha: ['', Validators.required],
    });
    this.get_delete_account_messages();
  }
  onSubmit(): void {
    this.submited = true;
    let email = this.exportForm.get('email')!.value;
    if (this.exportForm.valid) {
      if (!this.validate_email(email)) {
        this.email_validate = false;
        this.submited = false;
        this.field_empty = true;
        this.delete_account_message = false;
        this.clearLocalStorageMessage();
        return;
      }
      if (!email) {
        this.field_empty = false;
        this.email_validate = true;
        this.submited = false;
        this.delete_account_message = false;
        this.clearLocalStorageMessage();
        return;
      }
      this.recaptchaV3Service
        .execute('importantAction')
        .subscribe(async (token: string) => {
          if (token) {
            let user_details = { email: this.exportForm.get('email')!.value };
            (
              await this._controller_service.DataExport(user_details, token)
            ).subscribe(
              (success) => {
                this.router.navigate(['dataexport/success']);
              },
              (error) => {
                this.router.navigate(['error']);
              }
            );
          }
        });
    }
  }
  Reset() {
    // Handle reset event
    this.recaptcha_response = null; // Reset the stored response on reset
  }

  Expire() {
    // Handle expire event
    console.log('expired');
  }

  Load() {
    // Handle load event
    console.log('loaded');
  }

  Success(event: any) {
    // Handle success event
    this.recaptcha_response = event.token;
  }
  validate_email(email: string | null): boolean {
    if (email) {
      return emailRegex.test(email);
    } else {
      return true;
    }
  }
  clearLocalStorageMessage() {
    this.storage.removeFromLocalStorage('message');
  }

  get_delete_account_messages() {
    const message = this.storage.getFromLocalStorage('message');
    if (message && message.toLowerCase() == 'details not found') {
      this.delete_account_message = true;
    }
  }
}
